import { Component, Input, HostListener, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { States } from '../../enums/States';
import { Platform } from '@ionic/angular';
import { ModulesManagerService } from '../../classes/Module/modules-manager.service';
import { Ask } from '../../classes/Ask/ask.service';
import { StatsCalculator } from '../../classes/StatsCalculator/stats-calculator';
import { LoggerService } from '../../utils/logger.service';

@Component({
  selector: 'app-stats',
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class StatsComponent implements OnInit {
  view: [number, number]; // Add a property to store chart dimensions


  @ViewChild('chartContainer', { static: true }) chartContainer: ElementRef; // Use ViewChild to get a reference to the chart container

  private statCalculator: StatsCalculator

  @Input()
  set StatsCalculator(calculator: StatsCalculator) {
    if (this.statCalculator) this.statCalculator.Ready = false
    this.statCalculator = calculator
    this.statCalculator?.calculate()
  }

  get isReady() {
    return this.statCalculator?.Ready
  }

  get ColorSchem() {
    return this.statCalculator?.ColorScheme || {
      domain: []
    }
  }

  get Single() {
    return this.statCalculator?.Single || []
  }

  constructor(public platform: Platform, private manager: ModulesManagerService) {



  }

  onSelect(event) {
    LoggerService.debug('Événement sélectionné dans les stats', event);
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.updateChartDimensions();
  }

  updateChartDimensions() {
    // Update `view` to change chart dimensions based on window size
    const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0) * 0.8;

    // Example: Set the chart's width to be the full width of the viewport and height to be half of it
    // Adjust as needed for your specific design
    this.view = [width, width / 2];
  }

  ngOnInit() {
    this.updateChartDimensions();
  }
}
